// extracted by mini-css-extract-plugin
export default {"wrapper":"PayoutInfo_wrapper__KZd--","field":"PayoutInfo_field__Nykvw","fieldRow":"PayoutInfo_fieldRow__+50mZ","info":"PayoutInfo_info__lZ-lO"};